import React, { useState, useEffect } from 'react';
import './styles.css'; // Import the existing CSS
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Contact from './Contact'; // Import the new Contact component
import Home from './Home'; // Import the new Home component
import Employees from './Employees'; // Import Employees
import Service from './Service'; // Import the Employees component
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [showModal, setShowModal] = useState(true); // State for showing the popup

  // // Function to open the modal popup
  // const openModal = () => {
  //   setShowModal(true);
  // };

  // // Function to close the modal popup
  // const closeModal = () => {
  //   setShowModal(false);
  // };

  return (
    <Router>
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<Home />} />
        <Route path='/contact' element={<Contact />}></Route>
        {/* Contact Page */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/service" element={<Service />} />
      </Routes>
    </Router>
  );
}

export default App;
